import { render, staticRenderFns } from "./PdTabCreateInapp.vue?vue&type=template&id=3e6ddbcc&scoped=true&"
import script from "./PdTabCreateInapp.vue?vue&type=script&lang=ts&"
export * from "./PdTabCreateInapp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ddbcc",
  null
  
)

export default component.exports